(() => {
  const markPreviewBar = () => {
    const params = new URLSearchParams(window.location.search);
    const isThemePreview = params.has('preview_theme_id') && params.get('pb') !== '0';
    const hasPreviewIframe = !!document.querySelector('iframe[id*="preview"], iframe[src*="preview_bar"]');

    if (isThemePreview || hasPreviewIframe) {
      document.body.classList.add('has-preview-bar');
    } else {
      document.body.classList.remove('has-preview-bar');
    }
  };

  markPreviewBar();
  setTimeout(markPreviewBar, 1500);

  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const menuBackdrop = document.querySelector('[data-menu-backdrop]');
  const menuCloseButton = document.querySelector('[data-menu-close]');
  const menuButtonText = menuButton ? menuButton.querySelector('.menu-toggle__text') : null;
  const isMobileMenuViewport = () => window.matchMedia('(max-width: 860px)').matches;

  if (menuButton && mobileMenu) {
    const openLabel = menuButton.getAttribute('data-open-label') || 'Menu';
    const closeLabel = menuButton.getAttribute('data-close-label') || 'Close';
    let restoreFocusTarget = null;

    const getFocusableMenuItems = () =>
      Array.from(
        mobileMenu.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter((element) => !element.hasAttribute('hidden'));

    const openMenu = () => {
      restoreFocusTarget = document.activeElement;
      menuButton.setAttribute('aria-expanded', 'true');
      menuButton.setAttribute('aria-label', closeLabel);
      if (menuButtonText) {
        menuButtonText.textContent = closeLabel;
      }
      mobileMenu.classList.add('is-open');
      if (menuBackdrop) {
        menuBackdrop.classList.add('is-open');
      }
      document.body.classList.add('menu-open');

      const focusableItems = getFocusableMenuItems();
      if (focusableItems.length) {
        focusableItems[0].focus();
      }
    };

    const closeMenu = ({ restoreFocus = true } = {}) => {
      const wasOpen = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', 'false');
      menuButton.setAttribute('aria-label', openLabel);
      if (menuButtonText) {
        menuButtonText.textContent = openLabel;
      }
      mobileMenu.classList.remove('is-open');
      if (menuBackdrop) {
        menuBackdrop.classList.remove('is-open');
      }
      document.body.classList.remove('menu-open');

      if (restoreFocus && wasOpen && restoreFocusTarget && typeof restoreFocusTarget.focus === 'function') {
        restoreFocusTarget.focus();
      }
    };

    menuButton.addEventListener('click', () => {
      const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    mobileMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        if (isMobileMenuViewport()) {
          closeMenu();
        }
      });
    });

    if (menuCloseButton) {
      menuCloseButton.addEventListener('click', closeMenu);
    }

    if (menuBackdrop) {
      menuBackdrop.addEventListener('click', closeMenu);
    }

    document.addEventListener('click', (event) => {
      if (!isMobileMenuViewport()) {
        return;
      }

      if (
        !mobileMenu.contains(event.target) &&
        !menuButton.contains(event.target) &&
        (!menuBackdrop || !menuBackdrop.contains(event.target))
      ) {
        closeMenu();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMenu();
        return;
      }

      if (event.key !== 'Tab') {
        return;
      }

      const isMenuOpen = menuButton.getAttribute('aria-expanded') === 'true';
      if (!isMenuOpen || !isMobileMenuViewport()) {
        return;
      }

      const focusableItems = getFocusableMenuItems();
      if (!focusableItems.length) {
        return;
      }

      const firstItem = focusableItems[0];
      const lastItem = focusableItems[focusableItems.length - 1];

      if (event.shiftKey && document.activeElement === firstItem) {
        event.preventDefault();
        lastItem.focus();
      } else if (!event.shiftKey && document.activeElement === lastItem) {
        event.preventDefault();
        firstItem.focus();
      }
    });

    window.addEventListener('resize', () => {
      if (!isMobileMenuViewport()) {
        closeMenu({ restoreFocus: false });
      }
    });
  }

  const header = document.querySelector('.site-header');

  if (header) {
    const updateHeaderState = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };

    window.addEventListener('scroll', updateHeaderState, { passive: true });
    updateHeaderState();
  }

  const revealElements = document.querySelectorAll('[data-reveal]');

  if ('IntersectionObserver' in window && revealElements.length) {
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.08
      }
    );

    revealElements.forEach((element) => revealObserver.observe(element));
  } else {
    revealElements.forEach((element) => element.classList.add('is-visible'));
  }

  const productPage = document.querySelector('[data-product-page]');

  if (productPage) {
    const sectionRoot = productPage.closest('.premium-product') || document;
    const mediaItems = Array.from(productPage.querySelectorAll('[data-product-media-item]'));
    const thumbButtons = Array.from(productPage.querySelectorAll('[data-product-thumb]'));
    const variantSelect = productPage.querySelector('[data-product-variant-select]');
    const priceElement = productPage.querySelector('[data-product-price]');
    const compareElement = productPage.querySelector('[data-product-compare]');
    const addButton = productPage.querySelector('[data-product-add-button]');
    const addButtonText = productPage.querySelector('[data-product-add-button-text]');
    const availabilityElement = productPage.querySelector('[data-product-availability]');
    const mobileBar = sectionRoot.querySelector('[data-mobile-product-bar]');
    const mobileBarPrice = sectionRoot.querySelector('[data-mobile-product-price]');
    const mediaPrice = productPage.querySelector('[data-product-media-price]');
    const mobileBarBundleLabel = sectionRoot.querySelector('[data-mobile-product-bundle]');
    const mobileBarButton = sectionRoot.querySelector('[data-mobile-product-add-button]');
    const mobileBarButtonText = sectionRoot.querySelector('[data-mobile-product-add-button-text]');
    const qtyInput = productPage.querySelector('[data-product-qty-input]');
    const qtyButtons = Array.from(productPage.querySelectorAll('[data-product-qty-btn]'));
    const colorPicker = productPage.querySelector('[data-product-color-picker]');
    const colorSwatches = Array.from(productPage.querySelectorAll('[data-product-color-swatch]'));
    const colorOptionIndex = colorPicker ? Number(colorPicker.dataset.colorOptionIndex || 0) : 0;
    const bundleButtons = Array.from(productPage.querySelectorAll('[data-product-bundle]'));
    const bundlePropertyInput = productPage.querySelector('[data-bundle-property]');
    const bundleKeyPropertyInput = productPage.querySelector('[data-bundle-key-property]');
    const selectedBundleLabel = productPage.querySelector('[data-product-selected-bundle]');
    const heroElement = productPage.querySelector('[data-product-hero]');
    const moneyFormat = productPage.dataset.moneyFormat || '${{amount}}';
    let activeBundleButton = bundleButtons.find((button) => button.classList.contains('is-active')) || null;
    let hasPassedHero = false;

    const toNumber = (value, fallback = 0) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    const formatMoney = (cents) => {
      const normalized = Math.max(0, Math.round(toNumber(cents, 0)));

      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(normalized, moneyFormat);
      }

      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR'
      }).format(normalized / 100);
    };

    const getSelectedVariantOption = () => {
      if (!variantSelect) {
        return null;
      }
      return variantSelect.options[variantSelect.selectedIndex] || null;
    };

    const getBasePriceCents = () => {
      const selectedOption = getSelectedVariantOption();
      if (selectedOption) {
        return toNumber(selectedOption.dataset.priceRaw, toNumber(productPage.dataset.basePrice, 0));
      }
      return toNumber(productPage.dataset.basePrice, 0);
    };

    const getComparePriceCents = () => {
      const selectedOption = getSelectedVariantOption();
      if (!selectedOption) {
        return 0;
      }
      return toNumber(selectedOption.dataset.compareRaw, 0);
    };

    const getNormalizedQty = () => {
      if (!qtyInput) {
        return 1;
      }

      const parsedQty = Number.parseInt(qtyInput.value, 10);
      const nextQty = Number.isNaN(parsedQty) ? 1 : Math.max(1, parsedQty);
      qtyInput.value = String(nextQty);
      return nextQty;
    };

    const setBundleProperties = (label, key) => {
      if (bundlePropertyInput) {
        bundlePropertyInput.value = label;
      }
      if (bundleKeyPropertyInput) {
        bundleKeyPropertyInput.value = key;
      }
    };

    const setSelectedBundleLabel = (label) => {
      if (selectedBundleLabel) {
        selectedBundleLabel.textContent = `Geselecteerd: ${label}`;
      }
      if (mobileBarBundleLabel) {
        mobileBarBundleLabel.textContent = label;
      }
    };

    const setBundleButtonState = (activeButton) => {
      bundleButtons.forEach((button) => {
        const isActive = button === activeButton;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });
      activeBundleButton = activeButton || null;
    };

    const getBundlePricing = (button, basePriceCents) => {
      if (!button) {
        return {
          total: basePriceCents * getNormalizedQty(),
          qty: getNormalizedQty(),
          addonCents: 0,
          discountPercent: 0
        };
      }

      const qty = Math.max(1, toNumber(button.dataset.bundleQty, 1));
      const discountPercent = Math.max(0, toNumber(button.dataset.bundleDiscount, 0));
      const addonCents = Math.max(0, toNumber(button.dataset.bundleAddon, 0));
      const multiplier = (100 - discountPercent) / 100;
      let total = basePriceCents * qty;

      if (discountPercent > 0) {
        total = Math.round(total * multiplier);
      }

      total += addonCents;

      return {
        total,
        qty,
        addonCents,
        discountPercent
      };
    };

    const getBundleComparePricing = (button, comparePriceCents) => {
      if (!button) {
        return comparePriceCents * getNormalizedQty();
      }

      const qty = Math.max(1, toNumber(button.dataset.bundleQty, 1));
      const addonCents = Math.max(0, toNumber(button.dataset.bundleAddon, 0));
      return comparePriceCents * qty + addonCents;
    };

    const updateBundlePriceLabels = () => {
      if (!bundleButtons.length) {
        return;
      }

      const basePriceCents = getBasePriceCents();

      bundleButtons.forEach((button) => {
        const priceNode = button.querySelector('[data-bundle-price]');
        if (!priceNode) {
          return;
        }

        const pricing = getBundlePricing(button, basePriceCents);
        priceNode.textContent = formatMoney(pricing.total);
      });
    };

    const setActiveColorSwatch = (value) => {
      if (!colorSwatches.length) {
        return;
      }

      colorSwatches.forEach((button) => {
        const isActive = value && button.dataset.colorValue === value;
        button.classList.toggle('is-active', isActive);
      });
    };

    const setActiveMedia = (mediaId) => {
      if (!mediaId || !mediaItems.length) {
        return;
      }

      mediaItems.forEach((item) => {
        const isActive = item.dataset.mediaId === String(mediaId);
        item.classList.toggle('is-active', isActive);
        item.hidden = !isActive;

        const videoElement = item.querySelector('video');
        if (videoElement) {
          if (isActive) {
            videoElement.play().catch(() => {});
          } else {
            videoElement.pause();
          }
        }
      });

      thumbButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.mediaId === String(mediaId));
      });
    };

    const updateDisplayedPricing = () => {
      const basePriceCents = getBasePriceCents();
      const comparePriceCents = getComparePriceCents();
      let totalPriceCents = basePriceCents;
      let compareTotalCents = comparePriceCents;

      if (activeBundleButton) {
        const bundlePricing = getBundlePricing(activeBundleButton, basePriceCents);
        totalPriceCents = bundlePricing.total;
        compareTotalCents = getBundleComparePricing(activeBundleButton, comparePriceCents);
      } else if (qtyInput) {
        const qty = getNormalizedQty();
        totalPriceCents = basePriceCents * qty;
        compareTotalCents = comparePriceCents * qty;
      }

      if (priceElement) {
        priceElement.textContent = formatMoney(totalPriceCents);
      }

      if (mediaPrice) {
        mediaPrice.textContent = formatMoney(totalPriceCents);
      }

      if (mobileBarPrice) {
        mobileBarPrice.textContent = formatMoney(totalPriceCents);
      }

      if (compareElement) {
        if (compareTotalCents > totalPriceCents) {
          compareElement.hidden = false;
          compareElement.textContent = formatMoney(compareTotalCents);
        } else {
          compareElement.hidden = true;
          compareElement.textContent = '';
        }
      }
    };

    const setActiveBundle = (button, { syncQty = true } = {}) => {
      if (!button) {
        return;
      }

      setBundleButtonState(button);

      const bundleLabel = button.dataset.bundleLabel || button.textContent.trim();
      const bundleKey = button.dataset.bundleKey || 'single';
      const bundleQty = Math.max(1, toNumber(button.dataset.bundleQty, 1));

      setSelectedBundleLabel(bundleLabel);
      setBundleProperties(bundleLabel, bundleKey);

      if (qtyInput && syncQty) {
        qtyInput.value = String(bundleQty);
      }

      updateDisplayedPricing();
    };

    const setCustomQuantityBundle = (qty) => {
      setBundleButtonState(null);
      setSelectedBundleLabel(`${qty} stuks`);
      setBundleProperties(`Aantal ${qty}`, 'custom');
      updateDisplayedPricing();
    };

    const syncBundleWithQuantity = (qty) => {
      if (!bundleButtons.length) {
        updateDisplayedPricing();
        return;
      }

      if (activeBundleButton && toNumber(activeBundleButton.dataset.bundleQty, 1) === qty) {
        updateDisplayedPricing();
        return;
      }

      const matchedButton = bundleButtons.find((button) => {
        const key = button.dataset.bundleKey || '';
        const bundleQty = Math.max(1, toNumber(button.dataset.bundleQty, 1));
        return key !== 'dog' && bundleQty === qty;
      });

      if (matchedButton) {
        setActiveBundle(matchedButton, { syncQty: false });
      } else {
        setCustomQuantityBundle(qty);
      }
    };

    const updateAvailability = () => {
      const selectedOption = getSelectedVariantOption();
      const isAvailable = selectedOption ? selectedOption.dataset.available === 'true' : !addButton?.disabled;

      if (addButton) {
        addButton.disabled = !isAvailable;
      }

      if (mobileBarButton) {
        mobileBarButton.disabled = !isAvailable;
      }

      if (addButtonText) {
        const availableLabel = addButtonText.dataset.availableLabel || 'Nu kopen';
        const soldOutLabel = addButtonText.dataset.soldOutLabel || 'Uitverkocht';
        addButtonText.textContent = isAvailable ? availableLabel : soldOutLabel;
      }

      if (mobileBarButtonText) {
        const availableLabel = mobileBarButtonText.dataset.availableLabel || 'Nu kopen';
        const soldOutLabel = mobileBarButtonText.dataset.soldOutLabel || 'Uitverkocht';
        mobileBarButtonText.textContent = isAvailable ? availableLabel : soldOutLabel;
      }

      if (availabilityElement) {
        const availableLabel = availabilityElement.dataset.availableLabel || '';
        const soldOutLabel = availabilityElement.dataset.soldOutLabel || '';
        availabilityElement.textContent = isAvailable ? availableLabel : soldOutLabel;
        availabilityElement.classList.toggle('is-available', isAvailable);
        availabilityElement.classList.toggle('is-unavailable', !isAvailable);
      }
    };

    const updateVariantState = () => {
      const selectedOption = getSelectedVariantOption();

      if (selectedOption) {
        const mediaId = selectedOption.dataset.mediaId;
        if (mediaId) {
          setActiveMedia(mediaId);
        }

        if (colorOptionIndex > 0) {
          const selectedColor = selectedOption.dataset[`option${colorOptionIndex}`] || '';
          setActiveColorSwatch(selectedColor);
        }
      }

      updateBundlePriceLabels();
      updateAvailability();
      updateDisplayedPricing();
    };

    thumbButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const mediaId = button.dataset.mediaId;
        if (mediaId) {
          setActiveMedia(mediaId);
        }
      });
    });

    if (colorSwatches.length && variantSelect && colorOptionIndex > 0) {
      colorSwatches.forEach((swatch) => {
        swatch.addEventListener('click', () => {
          const selectedColor = swatch.dataset.colorValue || '';
          if (!selectedColor) {
            return;
          }

          const options = Array.from(variantSelect.options);
          const firstMatch = options.find(
            (option) =>
              option.dataset[`option${colorOptionIndex}`] === selectedColor &&
              option.dataset.available === 'true'
          );
          const fallbackMatch = options.find((option) => option.dataset[`option${colorOptionIndex}`] === selectedColor);
          const targetOption = firstMatch || fallbackMatch;

          if (!targetOption) {
            return;
          }

          variantSelect.value = targetOption.value;
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }

    if (qtyInput) {
      qtyButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const currentQty = getNormalizedQty();
          const delta = button.dataset.productQtyBtn === 'decrease' ? -1 : 1;
          const nextQty = Math.max(1, currentQty + delta);
          qtyInput.value = String(nextQty);
          syncBundleWithQuantity(nextQty);
        });
      });

      qtyInput.addEventListener('input', () => {
        const qty = getNormalizedQty();
        syncBundleWithQuantity(qty);
      });

      qtyInput.addEventListener('change', () => {
        const qty = getNormalizedQty();
        syncBundleWithQuantity(qty);
      });
    }

    if (bundleButtons.length) {
      bundleButtons.forEach((button) => {
        button.addEventListener('click', () => {
          setActiveBundle(button);
        });
      });

      if (!activeBundleButton) {
        activeBundleButton = bundleButtons[0];
      }

      if (activeBundleButton) {
        setActiveBundle(activeBundleButton);
      }
    } else if (qtyInput) {
      getNormalizedQty();
    }

    if (variantSelect) {
      variantSelect.addEventListener('change', updateVariantState);
    }

    updateVariantState();

    const isMobileProductViewport = () => window.matchMedia('(max-width: 860px)').matches;
    const updateMobileBarVisibility = () => {
      if (!mobileBar) {
        return;
      }

      const shouldShow = isMobileProductViewport() && hasPassedHero;
      mobileBar.classList.toggle('is-visible', shouldShow);
      mobileBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    };

    if (mobileBar) {
      if (heroElement && 'IntersectionObserver' in window) {
        const heroObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              hasPassedHero = !entry.isIntersecting;
              updateMobileBarVisibility();
            });
          },
          {
            threshold: 0.18
          }
        );

        heroObserver.observe(heroElement);
      } else {
        const fallbackScrollHandler = () => {
          const threshold = heroElement ? heroElement.offsetHeight * 0.65 : 360;
          hasPassedHero = window.scrollY > threshold;
          updateMobileBarVisibility();
        };

        window.addEventListener('scroll', fallbackScrollHandler, { passive: true });
        fallbackScrollHandler();
      }

      window.addEventListener('resize', updateMobileBarVisibility);
      updateMobileBarVisibility();
    }

    const accordions = Array.from(sectionRoot.querySelectorAll('[data-accordion]'));

    accordions.forEach((accordion) => {
      const triggers = Array.from(accordion.querySelectorAll('[data-accordion-trigger]'));
      if (!triggers.length) {
        return;
      }

      const setTriggerState = (trigger, expanded) => {
        const panelId = trigger.getAttribute('aria-controls');
        const panel = panelId ? document.getElementById(panelId) : null;
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (panel) {
          panel.hidden = !expanded;
        }
      };

      triggers.forEach((trigger) => {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        setTriggerState(trigger, isExpanded);

        trigger.addEventListener('click', () => {
          const currentlyExpanded = trigger.getAttribute('aria-expanded') === 'true';

          triggers.forEach((otherTrigger) => {
            if (otherTrigger !== trigger) {
              setTriggerState(otherTrigger, false);
            }
          });

          setTriggerState(trigger, !currentlyExpanded);
        });
      });
    });
  }

  const cartPage = document.querySelector('[data-cart-page]');

  if (cartPage) {
    const cartForm = cartPage.querySelector('[data-cart-form]');

    if (cartForm) {
      const qtyInputs = Array.from(cartForm.querySelectorAll('[data-cart-qty-input]'));
      const qtyButtons = Array.from(cartForm.querySelectorAll('[data-cart-qty-btn]'));
      const updateTrigger = cartForm.querySelector('[data-cart-update-trigger]');
      let updateTimerId = null;
      let isSubmitting = false;

      const normalizeQtyValue = (input, { allowBlank = false } = {}) => {
        const rawValue = input.value.trim();
        if (allowBlank && rawValue === '') {
          return null;
        }

        const minValue = Number(input.getAttribute('min') || 0);
        const parsedValue = Number.parseInt(rawValue, 10);
        const nextValue = Number.isNaN(parsedValue) ? minValue : Math.max(minValue, parsedValue);
        input.value = String(nextValue);
        return nextValue;
      };

      const scheduleCartUpdate = (delay = 320) => {
        if (!updateTrigger || isSubmitting) {
          return;
        }

        if (updateTimerId) {
          window.clearTimeout(updateTimerId);
        }

        updateTimerId = window.setTimeout(() => {
          isSubmitting = true;
          cartForm.classList.add('is-updating');

          if (typeof cartForm.requestSubmit === 'function') {
            cartForm.requestSubmit(updateTrigger);
          } else {
            updateTrigger.click();
          }
        }, delay);
      };

      qtyInputs.forEach((input) => {
        input.addEventListener('input', () => {
          const normalizedValue = normalizeQtyValue(input, { allowBlank: true });
          if (normalizedValue === null) {
            return;
          }
          scheduleCartUpdate(460);
        });

        input.addEventListener('change', () => {
          normalizeQtyValue(input);
          scheduleCartUpdate(240);
        });

        input.addEventListener('blur', () => {
          normalizeQtyValue(input);
        });
      });

      qtyButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const targetInputId = button.getAttribute('data-target-input');
          if (!targetInputId) {
            return;
          }

          const targetInput = document.getElementById(targetInputId);
          if (!targetInput) {
            return;
          }

          const normalized = normalizeQtyValue(targetInput, { allowBlank: true });
          const currentValue = normalized === null ? Number(targetInput.getAttribute('min') || 0) : normalized;
          const minValue = Number(targetInput.getAttribute('min') || 0);
          const direction = button.getAttribute('data-cart-qty-btn');
          const delta = direction === 'decrease' ? -1 : 1;
          const nextValue = Math.max(minValue, currentValue + delta);

          if (nextValue === currentValue) {
            return;
          }

          targetInput.value = String(nextValue);
          scheduleCartUpdate(120);
        });
      });
    }
  }

  document.querySelectorAll('[data-auto-submit]').forEach((element) => {
    element.addEventListener('change', () => {
      if (element.form) {
        element.form.submit();
      }
    });
  });
})();
